import { render, staticRenderFns } from "./web-request.vue?vue&type=template&id=21202af3&"
import script from "./web-request.vue?vue&type=script&lang=js&"
export * from "./web-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports